import React, { useLayoutEffect, useRef, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import messages from 'messages';
import List from 'components/list/List';
import ListBody from 'components/list/ListBody';
import { Card, CardBody } from 'components/card';
import Message from 'components/message/Message';
import MessageText from 'components/message/MessageText';
import ExerciseListItem from 'containers/partials/list-items/ExerciseListItem';
import { useUIDSeed } from 'react-uid';

const PersonProgramExercisesList = ({
  activeId,
  exercises = [],
  onClick,
  extraClassNames = {}
}) => {
  const parentRef = useRef();
  const uidSeed = useUIDSeed();
  const [setMinHeight] = useState(null);

  useLayoutEffect(() => {
    if (parentRef.current) {
      const roundedTop = parentRef.current
        .getBoundingClientRect()
        .top.toFixed(0);

      setMinHeight(`calc(100dvh - 16px - ${roundedTop}px)`);
    }
  }, [setMinHeight]);

  return (
    <>
      {exercises.length > 0 ? (
        <List extraClassNames={extraClassNames}>
          <ListBody>
            {exercises.map(exercise => {
              return (
                <ExerciseListItem
                  uid={uidSeed(exercise.id)}
                  key={uidSeed(exercise.id)}
                  exercise={exercise}
                  active={exercise.id === activeId}
                  checkbox
                  clickable
                  showNote
                  onClick={() => onClick && onClick(exercise.id)}
                />
              );
            })}
          </ListBody>
        </List>
      ) : (
        <Card centered>
          <CardBody empty>
            <Message emptyState={true} icon="cursor">
              <MessageText>
                <FormattedMessage {...messages.exercisesListEmpty} />
              </MessageText>
            </Message>
          </CardBody>
        </Card>
      )}
    </>
  );
};

export default PersonProgramExercisesList;
